import React, { useState } from 'react'
 
 
import PalletizationList from './PalletizationList';
import PalletizationForm from './PalletizationForm';

const Palletization= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <PalletizationForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <PalletizationList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}  
    </>
  )
}

export default Palletization